"use strict";

PF.Field.ButtonsToggle = class ButtonsToggle extends PF.Field
	{
	static get options()
		{
		return {
			html: PF.Field.ButtonsToggle.templates,
			listConfig: {
				modelsConfig: undefined,
				models: undefined,
				itemClass: PF.Field.ButtonsToggle.Button,
			},
			dom: {},
			simpleName: "@{model.name}",
			selectFirst: true,
			silentSetData: false
		};
		}

	static get templates()
		{
		return {
			//language=HTML
			wrapper: `
			 <div class="pf-button-toggle" pf="wrapper">
				 <div class="segmented segmented-raised" pf="ul">

				 </div>
			 </div>
			`,
		};
		}


	init()
		{
		// this.dom.element.addClass('segmented segmented-raised pf-button-toggle');

		this.list = new PF.Dom.List({
			dom: this.dom,
			...this.listConfig,
			buttonsToggle: this,
			html: this.html,
		});

		this.nullItem = this.list.create(new PF.Model({raw: null}));

		if (this.model.get(this.key, null, null) === null)
			{
			this.model.setData(this.key, this.nullItem.model, true);
			}


		this.onChange('model.' + this.key, () => {
			// console.log(`${this.name}: change model value`, this.model.get(this.key));
			this.selected = this.findItemByModel(this.model.get(this.key));
			this.validate(true);
		}, true);

		this.on('list.models.changed', () => {
			// console.log(`${this.name}: dict changed`, this.model.get(this.key));
			this.selected = this.findItemByModel(this.model.get(this.key));
			this.validate(true);
		});


		this.onChange('selected', () => {
			let newModel = new PF.Model({raw: this.selected.model.toJSON()});
			this.model.setData(this.key, newModel, this.silentSetData);
			// this.model.get(this.key).populateData(this.selected.model);
			// this.model.trigger('changed');
			if (this.idKey !== undefined)
				{
				this.model.setData(this.idKey, this.selected.model.get(this.dictIdKey), this.silentSetData);
				}
		}, true);

		this.list.models.onValue('dataStatus', 'allLoaded', () => {
			if (this.list.models.length > 0)
				{
				if (this.selectFirst === true && this.model.get(this.key).options.isNull === true)
					{
					this.selected = this.list[0];
					}
				}
		});
		}

	findItemByModel(model)
		{
		for (let i = 0; i < this.list.length; i++)
			{
			if (PF.H.compareByPks(model, this.list[i].model))
				{
				return this.list[i];
				}
			}
		return this.nullItem;
		}

	};


PF.Field.ButtonsToggle.Button = class Button extends PF.Dom.List.Item
	{
	get renderer()
		{
		// language=HTML
		return `
			<button class="button " type="button" pf="button">${this.list.buttonsToggle.simpleName}</button>`;
		}

	onRender()
		{
		super.onRender();
		this.bindDom({button: "class:button-active"}, "selected");

		this.dom.button.on('click', () => this.list.buttonsToggle.selected = this);
		this.onChange('list.buttonsToggle.selected', () => {
			this.selected = this.list.buttonsToggle.selected === this;
		});

		}

	};